import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import EmailIcon from "@material-ui/icons/Email";

var ToolbarSelect = function ToolbarSelect(_ref) {
  var franchise = _ref.franchise,
      props = _objectWithoutProperties(_ref, ["franchise"]);

  //   const classes = useStyles();
  console.log("ToolbarSelect Componenet", props);
  var content = null;

  switch (props.variant) {
    case "invoice":
      content = /*#__PURE__*/React.createElement("div", {
        className: "custom-toolbar-select"
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "Download as ZIP"
      }, /*#__PURE__*/React.createElement(IconButton //   className={classes.iconButton}
      , {
        onClick: function onClick() {
          return props.handleClick("download", props.selectedRows, props.displayData);
        }
      }, /*#__PURE__*/React.createElement(SystemUpdateAltIcon, null))), !franchise && /*#__PURE__*/React.createElement(Tooltip, {
        title: "Send notifications"
      }, /*#__PURE__*/React.createElement(IconButton //   className={classes.iconButton}
      , {
        onClick: function onClick() {
          return props.handleClick("download", props.selectedRows, props.displayData);
        }
      }, /*#__PURE__*/React.createElement(EmailIcon, null))));
      break;

    default:
      content = /*#__PURE__*/React.createElement("div", {
        className: "custom-toolbar-select"
      }, props.items.map(function (item) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          title: item.label
        }, /*#__PURE__*/React.createElement(IconButton //   className={classes.iconButton}
        , {
          onClick: function onClick() {
            return props.handleClick(item.action, props.selectedRows);
          }
        }, item.icon));
      }));
      break;
  }

  return content;
};

export { ToolbarSelect };